import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const CompanyMenuCompactLogo = ()=>{
    const $ = c(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("path", {
            d: "M5.94189 3.99998C5.94189 1.79084 7.73276 0 9.94189 0H69.9419C72.151 0 73.9419 1.79086 73.9419 4V722C73.9419 724.209 72.151 726 69.9419 726H9.94189C7.73276 726 5.94189 724.209 5.94189 722V3.99998Z",
            fill: "white"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsxs("g", {
            clipPath: "url(#clip0_19645_21216)",
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M23.9878 32.33C23.9878 25.1103 23.9878 21.5023 26.2319 19.2616C28.476 17.0211 32.0805 17.0176 39.3002 17.0176H40.6326C47.8487 17.0176 51.4568 17.0176 53.7009 19.2616C55.945 21.5058 55.9415 25.1103 55.9415 32.33V33.6623C55.9415 40.8785 55.9415 44.4866 53.7009 46.7307C51.4603 48.9748 47.8487 48.9713 40.6326 48.9713H39.3002C32.0805 48.9713 28.4725 48.9713 26.2319 46.7307C23.9913 44.4901 23.9878 40.8785 23.9878 33.6623V32.33Z",
                    fill: "#0077FF"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M55.9413 33.8839C55.9412 35.8374 55.9394 37.5227 55.8901 38.9857H48.0487C46.6171 38.9857 45.9013 38.9857 45.3544 38.7071C44.8734 38.462 44.4824 38.071 44.2373 37.59C43.9587 37.0432 43.9587 36.3273 43.9587 34.8957V34.1128C43.9587 32.3232 43.9587 31.4284 43.6104 30.7449C43.304 30.1437 42.8152 29.6548 42.214 29.3485C41.5304 29.0002 40.6357 29.0002 38.8461 29.0002H38.0632C36.6316 29.0002 35.9157 29.0002 35.3689 28.7216C34.8879 28.4765 34.4968 28.0854 34.2518 27.6044C33.9731 27.0576 33.9731 26.3418 33.9731 24.9101V17.0695C35.4917 17.0179 37.2502 17.0176 39.3 17.0176H40.6324C47.8485 17.0176 51.4566 17.0176 53.7008 19.2616C55.9178 21.4788 55.9411 25.0238 55.9413 32.0709C55.9413 32.1457 55.9413 32.2208 55.9413 32.2963V33.6623C55.9413 33.7366 55.9413 33.8104 55.9413 33.8839Z",
                    fill: "#00D9ED"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M29.979 40.7428C29.979 41.9782 30.9804 42.9796 32.2158 42.9796H37.1037C38.339 42.9796 39.3404 41.9782 39.3404 40.7428V35.8549C39.3404 34.6196 38.339 33.6182 37.1037 33.6182H32.2158C30.9804 33.6182 29.979 34.6196 29.979 35.8549V40.7428Z",
                    fill: "white"
                })
            ]
        });
        t2 = /*#__PURE__*/ jsx("rect", {
            x: "27.9419",
            y: "103.942",
            width: "22",
            height: "22",
            rx: "7",
            fill: "url(#paint0_linear_19645_21216)"
        });
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint0_linear_19645_21216",
            x1: "27.9419",
            y1: "115.132",
            x2: "49.4263",
            y2: "115.132",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.35",
                    stopColor: "#F4F6F8"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.5",
                    stopColor: "#F4F6F8",
                    stopOpacity: "0.4"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.75",
                    stopColor: "#F4F6F8"
                })
            ]
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ jsxs("svg", {
            width: "74",
            height: "161",
            viewBox: "0 0 74 161",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                /*#__PURE__*/ jsxs("defs", {
                    children: [
                        t3,
                        /*#__PURE__*/ jsx("clipPath", {
                            id: "clip0_19645_21216",
                            children: /*#__PURE__*/ jsx("rect", {
                                width: "31.9537",
                                height: "31.9537",
                                fill: "white",
                                transform: "translate(23.9878 17.0176)"
                            })
                        })
                    ]
                })
            ]
        });
        $[4] = t4;
    } else t4 = $[4];
    return t4;
};
export { CompanyMenuCompactLogo };
